// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"176157c5","320":"176157c5","504":"176157c5","592":"1cb48165","792":"176157c5","992":"176157c5"}[chunkId] + ".chunk.css";
};